import statusStore from "../../stores/statusStore";

export default function StatusDropdown({selectedShow, currentStatus, statusDDOpen, setStatusDDOpen}) {
    
    const staStore = statusStore();

    const endedOptions = [
        "Started",
        "To Watch",
        "Stopped",
        "Finished",
        "Not Interested"
    ];
    const continuingOptions = [
        "Started",
        "To Watch",
        "Stopped",
        "Finished what's available",
        "Not Interested"
    ];

    const handleSelect = async (value, airingStatus) => {
        setStatusDDOpen(false);
        await staStore.updateStatus(selectedShow._id, value, airingStatus);
        await staStore.fetchStatus();
    };

    return (
        <div>
            {selectedShow.airingStatus==="Ended" && <div class="dropdown">
                <button type="button" onClick={() => setStatusDDOpen(!statusDDOpen)} className="statusDropdown" > 
                    {currentStatus || "Select status..."}
                    <img className="chevronIcon" src="/assets/icons/chevron-down-black.png"></img>
                </button>
                {statusDDOpen && (
                    <ul className="statusDropdownMenu">
                    {endedOptions.map((option) => (
                        <li
                        key={option}
                        className={`dropdown-item ${option === currentStatus ? "selected" : ""}`}
                        onClick={() => handleSelect(option, selectedShow.airingStatus)}
                        >
                        {option}
                        </li>
                    ))}
                    </ul>
                )}
            </div>}
            {selectedShow.airingStatus==="Continuing" && <div class="dropdown">
                <button type="button" onClick={() => setStatusDDOpen(!statusDDOpen)} className="statusDropdown" > 
                    {currentStatus || "Select status..."}
                    <img className="chevronIcon" src="/assets/icons/chevron-down-black.png"></img>
                </button>
                {statusDDOpen && (
                    <ul className="statusDropdownMenu">
                    {continuingOptions.map((option) => (
                        <li
                        key={option}
                        className={`dropdown-item ${option === currentStatus ? "selected" : ""}`}
                        onClick={() => handleSelect(option, selectedShow.airingStatus)}
                        >
                        {option}
                        </li>
                    ))}
                    </ul>
                )}
            </div>}
        </div>
    )
}